import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import SubPageHeader from '../components/SubPageHeader';
import StoveFamilyList from '../components/StoveFamilyItems';

export default function PreWorkPage({ data }) {
  const families = data.families.nodes;
  return (
    <Layout>
      <SubPageHeader title="Pre-Work" />
      <StoveFamilyList families={families} parentUrl="pre-work" />
    </Layout>
  );
}

export const query = graphql`
  query {
    families: allSanityStoveFamily {
      nodes {
        id
        name
        image {
          asset {
            fluid(maxWidth: 400) {
              ...GatsbySanityImageFluid
            }
          }
        }
        url {
          current
        }
      }
    }
  }
`;
